import React from "react";
import { Capacitor } from "@capacitor/core";
import { IonButton, IonButtons, IonContent, IonHeader, IonImg, IonModal, IonToolbar } from "@ionic/react";
import DataController from "@controllers/DataController";
import HeaderTitle from "@components/common/HeaderTitle";
import { useTextToSpeech } from "@hooks/accessibility/useTextToSpeech";
import { useRecoilValue } from "recoil";
import { IAccessibilitySettings } from "@interfaces/Interfaces";
import { accessibilityAtom } from "@state/State";
import { Button_Audio_Stop, Button_Audio_Play_White } from "@assets/images";
import ContentContainer from "@components/common/ContentContainer";
import DOMPurify from "dompurify";
import { useAuditHelp } from "@hooks/app/useAuditHelp";
import "./ProfileComponents.css";

type Props = {
  visible: boolean;
  closeModal: () => void;
};

const AuditProfileHelpModal = (props: Props) => {
  const accessibilitySettings = useRecoilValue<IAccessibilitySettings | null>(accessibilityAtom);

  const { handleTTS, playing, stopTTS } = useTextToSpeech("audit-help-modal-container");
  const { content } = useAuditHelp();

  const auditHelpContent = content.find((item) => item.Section === "Audit Help CSS");

  const sanitizeData = (data: string) => ({
    __html: DOMPurify.sanitize(data, {
      ADD_TAGS: ["iframe"],
      ALLOWED_ATTR: [
        "class",
        "width",
        "height",
        "src",
        "title",
        "target",
        "rel",
        "href",
        "title",
        "allow",
        "referrerPolicy",
        "allowFullScreen",
      ],
    }),
  });

  return (
    <IonModal
      id="audit-help-modal"
      isOpen={props.visible}
      onIonModalWillDismiss={() => {
        stopTTS();
        props.closeModal();
      }}
      backdropDismiss
      canDismiss
      className="fullscreen"
    >
      <IonHeader>
        <IonToolbar
          mode="ios"
          className="navBar"
          style={{
            maxWidth: DataController.isWeb() ? 980 : undefined,
            height: Capacitor.getPlatform() === "android" ? "54px" : "unset",
          }}
        >
          <IonButtons slot="start">
            <IonButton
              mode="ios"
              className="cancelButton"
              onClick={() => {
                stopTTS();
                props.closeModal();
              }}
            >
              {"Close"}
            </IonButton>
          </IonButtons>
          <HeaderTitle>{"Help"}</HeaderTitle>
          <IonButtons slot="end">
            {accessibilitySettings?.textToSpeech && (
              <IonButton
                mode="ios"
                className="cancelButton"
                onClick={() => handleTTS()}
              >
                <IonImg
                  src={playing ? Button_Audio_Stop : Button_Audio_Play_White}
                  className="headerIcon"
                />
              </IonButton>
            )}
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="page-background whiteBackground">
        <ContentContainer>
          <div
            className="infoModalContainer"
            id="audit-help-modal-container"
          >
            {auditHelpContent?.Title && <h1>{auditHelpContent.Title}</h1>}
            {auditHelpContent?.HTML && (
              <div
                className="tipModalText mx-0 mt-0"
                dangerouslySetInnerHTML={sanitizeData(auditHelpContent.HTML)}
              />
            )}
          </div>
        </ContentContainer>
      </IonContent>
    </IonModal>
  );
};

export default AuditProfileHelpModal;
